import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configurations from config file

/**
 * Class representing the view for table partners sub-provider.
 * @extends JetView
 */
export default class tablePartnersSubProviderView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        var vthis = this; // Reference to the current instance

        // Configuration for the double list component
        var list1 = {
            view: 'dbllist',
            id: 'dbllist', // ID for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Sub Proveedores no agregados'), // Left label for unadded sub-providers
            labelRight: _('Sub Proveedores Agregados'), // Right label for added sub-providers
            data: [], // Initial data for the list
        };

        // Return the main form configuration
        return {
            view: 'form',
            id: 'f1', // ID for the form
            rows: [
                {
                    view: 'forminput', // Input field for the form
                    name: 'access', // Name of the input
                    body: list1, // Body of the input
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Alignment of the label
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var values = ''; // Variable to hold values
        var string1 = ''; // Variable to hold query string

        // Event listener for filtering sub-providers
        this.on(this.app, 'partnerSubProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ''; // Reset query string

            // Iterate through filter data entries
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clear the double list and set its value to empty
            $$('dbllist').$$('left').clearAll();
            $$('dbllist').setValue([]);

            // AJAX request to fetch sub-providers based on filters
            webix.ajax().get(devConfig.geturlApi() + 'PartnersSubProviders/GetGroupPartnersSubProviders', string1, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse response data
                    if (!data.HasError) {
                        // If no error in response
                        $$('dbllist').$$('left').clearAll(); // Clear the left list
                        $$('dbllist').setValue([]); // Reset value
                        $$('dbllist').parse(data.Data.ExcludedProvidersList); // Parse excluded providers into the list
                        $$('dbllist').setValue(data.Data.IncludedProvidersList); // Set included providers as the current value
                        values = data.Data.IncludedProvidersList; // Store included providers
                    } else {
                        webix.message('Error! '); // Show error message if there's an error
                    }
                },
            });
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            var array1 = values.split(','); // Split current values into an array
            var array2 = $$('dbllist').getValue().split(','); // Get new values from the list
            var arrayAgregados = []; // Array to hold added items
            var arrayEliminados = []; // Array to hold removed items

            // Determine which items were added
            array2.forEach(function (obj) {
                var found = array1.find(function (element) {
                    return element == obj; // Check if the item was previously included
                });
                if (found == undefined) {
                    arrayAgregados.push(obj); // If not found, add to added items
                }
            });

            // Determine which items were removed
            array1.forEach(function (obj) {
                var found = array2.find(function (element) {
                    return element == obj; // Check if the item is still included
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // If not found, add to removed items
                }
            });



            // Create a confirmation window for the user
            webix
                .ui({
                    view: 'window',
                    head: {
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        view: 'form',
                        id: 'form', // ID for the confirmation form
                        elements: [
                            {
                                view: 'text', // Text input for observation
                                label: _('Observación'), // Label for the input
                                name: 'Note', // Name of the input
                                required: true, // Not required
                                labelWidth: 100, // Width of the label
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Button label
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('form').setValues($$('form').getCleanValues()); // Reset form values
                                            // Re-fetch the sub-providers
                                            webix
                                                .ajax()
                                                .get(
                                                    devConfig.geturlApi() +
                                                        'PartnersSubProviders/GetGroupPartnersSubProviders',
                                                    string1,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Show error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var data = JSON.parse(text); // Parse response data
                                                            if (!data.HasError) {
                                                                $$('dbllist').$$('left').clearAll(); // Clear the left list
                                                                $$('dbllist').setValue([]); // Reset value
                                                                $$('dbllist').parse(data.Data.ExcludedProvidersList); // Parse excluded providers into the list
                                                                $$('dbllist').setValue(data.Data.IncludedProvidersList); // Set included providers as the current value
                                                                values = data.Data.IncludedProvidersList; // Store included providers
                                                            } else {
                                                                webix.message('Error! '); // Show error message if there's an error
                                                            }
                                                        },
                                                    },
                                                );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form',
                                        value: _('Guardar'), // Button label
                                        click: function ($e) {
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                // Validate the form
                                                var vthis = this; // Reference to the current instance
                                                this.getTopParentView().hide(); // Hide the window
                                                // AJAX request to save the changes
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() +
                                                            'PartnersSubProviders/SaveGroupPartnersSubProviders',
                                                        '{"Partner":"' +
                                                            id_partner +
                                                            '","IncludedProvidersList":"' +
                                                            arrayAgregados +
                                                            '","ExcludedProvidersList":"' +
                                                            arrayEliminados +
                                                            '","Note":"' +
                                                            valuesForm.Note +
                                                            '"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Show error message on failure
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(text); // Parse response data
                                                                if (!data.HasError) {
                                                                    webix.message(_('Sub Proveedor Partner Editado')); // Show success message
                                                                    values = $$('dbllist').getValue(); // Update values with current selection
                                                                } else {
                                                                    webix.message(_('Error! ')); // Show error message if there's an error
                                                                }
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error title
                                                    type: 'alert-error', // Error type
                                                    text: _('Completa los campos...'), // Error message
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate the form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
